import { httpClient } from "@/services";

export default {
	state: {
		settingsDepartments: [],
		itemsDepartments: [],
		filtersDepartments: {},
		editDepartments: {},
		editDepartmentsUsers: {},
	},
	mutations: {
		updateDepartments(state, { settings, items, filters }) {
			state.settingsDepartments = settings;
			state.itemsDepartments = items;
			state.filtersDepartments = filters;
		},
		updateEditDepartments(state, { department, users }) {
			state.editDepartments = department;
			state.editDepartmentsUsers = users;
		},
	},
	actions: {

		async deleteAccountDepartments({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/departments/${ id }`);
				if (data && data.status) {
					dispatch('getAccountDepartmentsList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountDepartmentsList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/departments");
				if (data) {
					commit('updateDepartments', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountDepartmentsEdit({ commit, dispatch }, values ) {
			try {
				const { id } = values;
				const { data } = await httpClient.put(`/info/departments/${ id }`, values);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountDepartmentsCreate({ commit, dispatch } ) {
			try {
				const { data } = await httpClient.get(`/info/departments/create`);
				if ( data ) {
					commit('updateEditDepartments', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountDepartmentsSave({ commit, dispatch }, values) {
			// dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/info/departments", values);
				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountDepartmentsEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/departments/${ id }/edit`);
				if (data && data.status) {
					commit('updateEditDepartments', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},

	getters: {
		editDepartments: s => s.editDepartments,
		settingsDepartments: s => s.settingsDepartments,
		itemsDepartments: s => s.itemsDepartments,
		filtersDepartments: s => s.filtersDepartments,
		editDepartmentsUsers: s => s.editDepartmentsUsers,
	},
};
